<template>
	<div v-if="date" class="element__dateTime">
		<div v-if="dayname || day || month || year" class="element__date">
			<div v-if="dayname" class="element__dayname">{{ formatDate(date, 'dd') }}</div>
			<div v-if="day" class="element__day">{{ formatDate(date, 'DD') }}</div>
			<div v-if="month" class="element__month">{{ formatDate(date, 'MM') }}</div>
			<div v-if="year" class="element__year">{{ formatDate(date, 'YYYY') }}</div>
		</div>
		<div v-if="time" class="element__time">{{ formatDate(date, 'HH.mm') }}</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { setDayjsLocale } from '../../assets/dayjsLocales';

export default {
	props: {
		date: Date,
		dayname: Boolean,
		day: Boolean,
		month: Boolean,
		year: Boolean,
		time: Boolean,
	},
	methods: {
		formatDate(date, format) {
			setDayjsLocale(this.currentLanguage, this.$store.dispatch).then(() => {});
			return dayjs(date).format(format);
		},
	},
	computed: {
		...mapGetters(['currentLanguage']),
	},
};
</script>

<style lang="scss"></style>
